"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var wipModal = exports.wipModal = {
  unavailable_content: "This page isn't available in your language yet. Would you like to see it in Spanish?",
  continue_in_spanish: 'View the Spanish site'
};


//////////////////
// WEBPACK FOOTER
// ../i18n/lib/en/wipModal.js
// module id = 722
// module chunks = 0